import MetaTitle from '@/next/components/MetaTitle/MetaTitle';

export default MetaTitle;
